import {useSelector} from 'react-redux';
import {FmlxIcon} from 'fmlx-common-ui';
import {getAutoA1OffsetProgress} from 'stores/selectors/wizardSelectors';
import {parseMessage} from 'lib/stringHelper';

export default function A1OffsetCalibrationLoading() {
  const autoA1OffsetCallibrationProgress = useSelector(getAutoA1OffsetProgress);

  return (
    <>
      <div style={{margin: '10px 0', position: 'relative', top: '5px'}}>
        {parseMessage('tipsPickupCalibration.calibrationLoading', {
          loadPercentage: autoA1OffsetCallibrationProgress,
        })}
      </div>
      <span className="white-warning-container">
        <FmlxIcon name="Info" size="sm" customColor="red" />
        {parseMessage('tipsPickupCalibration.calibrationLoading.warning')}
      </span>
    </>
  );
}
